import { Component, ElementRef, ViewChild } from '@angular/core';
import { UtilService } from '../../../../services/util.service';
import { Location } from '@angular/common';
import { ModalDatosAdicionalesComponent } from '../../modal-datos/modal-datos-adicionales/modal-datos-adicionales.component';
import { ModalDatosAdicionalesAbogadoComponent } from '../../modal-datos/modal-datos-adicionales-abogado/modal-datos-adicionales-abogado.component';
import { Constants } from '../../../../constants/constants';
import { DataUsuario } from '../../../configuracion-cuenta/dto/data-usuarioDTO';
import { PoliticaTratamientoService } from '../services/politica-tratamiento.service';
import { AutenticacionService } from '../../../auth/services/autenticacion.service';

@Component({
  selector: 'app-politica-tratamiento-datos-personales',
  templateUrl: './politica-tratamiento-datos-personales.component.html',
  styleUrl: './politica-tratamiento-datos-personales.component.scss',
})
export class PoliticaTratamientoDatosPersonalesComponent {
  @ViewChild('modalPolitica') modalPolitica!: ElementRef;
  @ViewChild(ModalDatosAdicionalesComponent)
  ModalDatosAdicionalesComponent!: ModalDatosAdicionalesComponent;
  @ViewChild(ModalDatosAdicionalesAbogadoComponent)
  ModalDatosAdicionalesAbogadoComponent!: ModalDatosAdicionalesAbogadoComponent;

  dataUsuario!: DataUsuario;

  isPersona: boolean = false;
  openModalPersona: boolean = false;
  isAbogado: boolean = false;
  openModalAbogado: boolean = false;

  constructor(
    private autenticacionService: AutenticacionService,
    private location: Location,
    private servicePolitica: PoliticaTratamientoService
  ) {
    this.verificarUsuario();
  }

  verificarUsuario() {
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    this.dataUsuario = infoInicioSesion;
    if (infoInicioSesion.tipoUsuario.Id == 2) {
      // Usuario Ciudadano
      this.isPersona = true;
    } else if (infoInicioSesion.tipoUsuario.Id == 1) {
      // Usuario Abogado
      this.isAbogado = true;
    }
  }

  abrirModalPersona() {
    this.servicePolitica
      .aceptaPoliticaPersona(this.dataUsuario.idUsuario)
      .subscribe(response => response);
    this.openModalPersona = true;
    setTimeout(() => {
      this.ModalDatosAdicionalesComponent.abrirModal();
      this.dataUsuario.aceptoDatos = true;
      sessionStorage.setItem(
        Constants.USER_INFORMATION_STORAGE,
        JSON.stringify(this.dataUsuario)
      );
    }, 500);
  }

  // abrirModalAbogado() {
  //   this.servicePolitica
  //     .aceptaPoliticaAbogado(this.dataUsuario.idUsuario)
  //     .subscribe(response => response);
  //   this.openModalAbogado = true;
  //   setTimeout(() => {
  //     this.ModalDatosAdicionalesAbogadoComponent.abrirModal(false);
  //     this.dataUsuario.aceptoDatos = true;
  //     sessionStorage.setItem(
  //       Constants.USER_INFORMATION_STORAGE,
  //       JSON.stringify(this.dataUsuario)
  //     );
  //   }, 500);
  // }

  cancelar() {
    this.autenticacionService.logout();
    this.location.back();
  }

  abrirModal() {
    this.modalPolitica.nativeElement.click();
  }
}
